import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'System|Pages|Access Denied';

export type AccessDeniedLocs =
	| 'SPSystemAccessDeniedTitle'
	| 'SPSystemAccessDeniedContent'
	| 'SPSystemAccessDeniedButton'
	| 'CPSystemAccessDeniedTitle'
	| 'CPSystemAccessDeniedContent'
	| 'CPSystemAccessDeniedButton';

export const accessDeniedLocs: LocDefs<AccessDeniedLocs> = {
	SPSystemAccessDeniedTitle: {
		defaultValue: 'Access Denied',
		displayPath: `${dpRoot}|Title`,
		description: 'Title for the access denied page.',
		displayType: 'Title',
		feature: HubFeature.Core,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPSystemAccessDeniedContent: {
		defaultValue: '',
		displayPath: `${dpRoot}|Content`,
		description:
			'Content displayed on the access denied page. Leave blank to just display the title and button.',
		displayType: 'Content',
		feature: HubFeature.Core,
		htmlAllowed: true,
		shared: false,
		portal: 'SP',
	},
	SPSystemAccessDeniedButton: {
		defaultValue: 'Go Back',
		displayPath: `${dpRoot}|Button`,
		description: 'Text displayed in the go back button.',
		displayType: 'Button',
		feature: HubFeature.Core,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	CPSystemAccessDeniedTitle: {
		defaultValue: 'Access Denied',
		displayPath: `${dpRoot}|Title`,
		description: 'Title for the access denied page.',
		displayType: 'Title',
		feature: HubFeature.Core,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPSystemAccessDeniedContent: {
		defaultValue: '',
		displayPath: `${dpRoot}|Content`,
		description:
			'Content displayed on the access denied page. Leave blank to just display the title and button.',
		displayType: 'Content',
		feature: HubFeature.Core,
		htmlAllowed: true,
		shared: false,
		portal: 'CP',
	},
	CPSystemAccessDeniedButton: {
		defaultValue: 'Go Back',
		displayPath: `${dpRoot}|Button`,
		description: 'Text displayed in the go back button.',
		displayType: 'Button',
		feature: HubFeature.Core,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
};

export const LOC_KEYS = MapLocKeys<AccessDeniedLocs>(accessDeniedLocs);
export type AccessDeniedLocType = LocMap<AccessDeniedLocs>;
